<template>
    <section class="section is-medium is-primary has-text-centered is-long">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-half desc-hero-new">
                    <div class="wow fadeInLeft" data-wow-duration=".5s" data-wow-delay=".5s">
                        <h1 class="title">
                            {{ titlePort }}
                        </h1>
                        <h3 class="subtitle is-size-5 has-text-justified">
                            {{ subtitlePort }}
                        </h3>
                        <a :href="linkPort" v-if="visiblePort" class="button is-blue-reverse is-br-10 is-outlined is-medium" target="_blank">View website &nbsp;<i class="fas fa-chevron-right"></i></a>
                    </div>
                </div>
                <div class="column is-half">
                    <h1 class="title">
                        <img class="wow fadeInRight" data-wow-duration=".5s" data-wow-delay=".5s" :src="imagePort" :alt="altPort">
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['titlePort', 'subtitlePort', 'imagePort', 'altPort', 'linkPort', 'visiblePort']
}
</script>
